import * as z from 'zod';

export const AppConfigSchema = z.object({
  auth: z.object({
    authority: z.string(),
    clientId: z.string(),
  }),
  locationsApiUrl: z.string(),
  logging: z
    .object({
      connectionString: z.string().optional(),
    })
    .optional(),
  managementPortalApi: z.object({
    apiHost: z.string(),
  }),
  supportedLocations: z.array(z.string()),
  tenancy: z.object({
    apiHost: z.string(),
  }),
});

export type AppConfig = z.infer<typeof AppConfigSchema>;

export type AppConfigState =
  | { config: AppConfig; status: 'success' }
  | { error: string; status: 'error' }
  | { status: 'loading' };

export interface AppConfigProviderProps {
  children: React.ReactNode;
}
